module.exports = __webpack_public_path__ + "static/media/Moksh_Headshot.dd4e77cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PersonalImages/Moksh_Headshot.jpg
// module id = 594
// module chunks = 0